import { type Epic, combineEpics } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import { request } from '@/core';
import { closeModal } from '@/core/features/modal';
import { openSnackbar } from '@/core/features/snackbar';
import { setNewLogoRequest } from '@/api/teams';
import { fetchCompetitors, setNewLogo } from '../actions';

const setNewLogoEpic: Epic = (action$) =>
  action$.pipe(
    filter(setNewLogo.match),
    request(({ payload }) => setNewLogoRequest(payload), setNewLogo),
  );

const fetchCollectionSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(setNewLogo.succeeded.match),
    mergeMap(() => [
      closeModal(),
      fetchCompetitors({}),
      openSnackbar({
        snackbarType: 'success',
        snackbarMessage: 'Οι αλλαγές σας έχουν αποθηκευτεί',
      }),
    ]),
  );

export default combineEpics(setNewLogoEpic, fetchCollectionSucceededEpic);
